import { createReducer, on } from "@ngrx/store";
import { TableComponentState } from "../../shared/types/TableComponentState";
import { InitReleaseActions } from "../actions";

export const initReleaseTableStateKey = 'initReleaseTableState';

export interface State extends TableComponentState {

}

export const initialInitReleaseTableState: State = {
    loading: false,
    error: '',
    hasError: false,
    gridReady: false,
    isInitialLoad: true,
    printClicked: false,
    hasEmptyResponse: false
}

export const initReleaseTableStateReducer = createReducer(
    initialInitReleaseTableState,
    on(InitReleaseActions.hasEmptyResponse, (state) => {
        return {
            ...state,
            hasEmptyResponse: true
        }
    }),
    on(InitReleaseActions.printClicked, (state) => {
        return {
            ...state,
            printClicked: true
        }
    }),
    on(InitReleaseActions.getInitReleaseList, (state) => {
        return {
            ...state,
            loading: true,
            error: '',
            hasError: false
        }
    }),
    on(InitReleaseActions.getInitReleaseListSuccessful, (state) => {
        return {
            ...state,
            loading: false,
            error: '',
            hasError: false
        }
    }),
    on(InitReleaseActions.getInitReleaseListFailed, (state, response) => {
        return {
            ...state,
            loading: false,
            error: response.message,
            hasError: true
        }
    })
);
